import React from "react";
import contentfulUpdatesFactory from "@insightfulscience/contentful/Apps/Updates";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import SectionTryForFree from "../../SectionTryForFree";
import SiteLayout from "../../SiteLayout";
import withErrorHandling from "../../AppError/withErrorHandling";
import Page from "../../contentful/Apps/Updates/Page";
import resources from "../../../locales";
import { contentfulProps } from "../../config";

const updatesLayout = ({ children }) => {
	return (
		<SiteLayout>
			{children}
			<SectionTryForFree />
		</SiteLayout>
	);
};

const ContenfulUpdatesApp = contentfulUpdatesFactory({
	Layout: updatesLayout,
	contentfulProps,
	pageProps: {
		resources,
		PageComponent: Page,
		brandCode: "gn",
		siteDomain: "https://www.geneious.com",
	},
});

export default pipe(ContenfulUpdatesApp, withErrorHandling);
